
import { defineComponent } from "vue";

import Template from "@/components/Templates/index.vue";
import CareersDetail from "@/components/CareerDetail/Template1/index.vue";

export default defineComponent({
  components: {
    CareersDetail,
    Template,
  },
});
